import 'core-js/es/array/from';
import 'core-js/es/object/entries';
import 'core-js/es/symbol';
import 'core-js/es/symbol/iterator';
import 'promise-polyfill/src/polyfill';
import 'intersection-observer';
